export default function IsNumeric(input: any) {
  if (
    (typeof input === 'string' && input.startsWith('0x')) ||
    typeof input === 'boolean'
  )
    return false;
  return input - 0 == input && ('' + input).trim().length > 0;
}
